import { reducerWithInitialState } from 'typescript-fsa-reducers'
import * as Sentry from '@sentry/react';

import { UserInitialState, LoggedInUserActions } from '.'

export default reducerWithInitialState(UserInitialState)
.case(LoggedInUserActions.setLoggedInUser, (state, loggedInUser) => {

  if (process.env.REACT_APP_ENV !== 'local') {
    // sentry user
    Sentry.setUser({
      id: loggedInUser.id,
      email: loggedInUser.email,
    })
  }

  return {
    ...state,
    ...loggedInUser,
  }
})
